import cpkgubernurReducer from './reducers'

export default cpkgubernurReducer

